import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { FiMail, FiArrowLeft, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import './Login.css'; // Reuse the same styles

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const { resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await resetPassword(email);
      setSuccess(true);
      // Optionally redirect after a delay
      setTimeout(() => {
        navigate('/login');
      }, 5000);
    } catch (err) {
      let friendlyErrorMessage = 'Failed to send reset email. Please try again.';
      
      switch (err.code) {
        case 'auth/invalid-email':
          friendlyErrorMessage = 'Invalid email format.';
          break;
        case 'auth/user-not-found':
          friendlyErrorMessage = 'No account found with this email address.';
          break;
        case 'auth/too-many-requests':
          friendlyErrorMessage = 'Too many attempts. Please try again later.';
          break;
        default:
          console.error('Password reset error:', err);
      }
      setError(friendlyErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-content">
          {/* Logo and Branding */}
          <div className="login-header">
            <img src="/Block Logo-01.png" alt="Block Logo" className="login-logo" />
            <h1 className="login-title">Reset Password</h1>
            <p className="login-subtitle">Enter your email to receive reset instructions</p>
          </div>

          {/* Error Display */}
          {error && (
            <div className="error-alert">
              <FiAlertCircle className="error-icon" />
              <span>{error}</span>
            </div>
          )}

          {/* Success Display */}
          {success && (
            <div className="success-alert" style={{
              backgroundColor: '#d4edda',
              border: '1px solid #c3e6cb',
              color: '#155724',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <FiCheckCircle className="success-icon" style={{ color: '#155724' }} />
              <span>Password reset email sent! Check your inbox.</span>
            </div>
          )}

          {/* Reset Form */}
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading || success}
                  autoComplete="email"
                  autoFocus
                />
              </div>
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={loading || !email || success}
            >
              {loading ? 'Sending...' : 'Send Reset Email'}
            </button>
          </form>

          {/* Footer Links */}
          <div className="login-footer">
            <Link to="/login" className="back-to-login" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              color: '#007bff',
              textDecoration: 'none',
              marginBottom: '16px'
            }}>
              <FiArrowLeft />
              Back to Login
            </Link>
            <p>
              Need help?{' '}
              <Link to="/contact" className="register-link">
                Contact us
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
